import { memo, useCallback } from 'react';

import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard, type StringArrayFilterCardProps } from '~/components/Filters/StringArrayFilterCard';
import { PrivateVideoAspectRatiosSelect } from '~/components/Filters/VideoAspectRatioFilter/components/PrivateVideoAspectRatiosSelect';

type PrivateVideoAspectRatioFilterCardProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseFilterCardProps;

export const PrivateVideoAspectRatioFilterCard = memo(
  ({ boardId, libraryId, ...props }: PrivateVideoAspectRatioFilterCardProps) => {
    const renderVideoAspectRatiosSelect = useCallback<StringArrayFilterCardProps['StringSelect']>(
      (props) => <PrivateVideoAspectRatiosSelect libraryId={libraryId} boardId={boardId} {...props} />,
      [boardId, libraryId],
    );

    return (
      <StringArrayFilterCard
        filter="videoAspectRatios"
        filterCardType="videoAspectRatio"
        StringSelect={renderVideoAspectRatiosSelect}
        {...props}
      />
    );
  },
);

PrivateVideoAspectRatioFilterCard.displayName = 'PrivateVideoAspectRatioFilterCard';
